<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="staffMemberForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="staffMember" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                staffMemberForm: () => import('../forms/StaffMemberForm'),
                staffMember: () => import('../editViews/StaffMember'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'Name', value: 'name' },
                    { text: 'Job Title', value: 'jobTitle' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                ],
                itemsField: 'staffMembers',
                editPageName: 'staffMember',
                apiMethod: 'StaffMembers',
                claimName: 'StaffMembers',
                formTitle: 'Staff Member',
                excelTitle: 'Staff Members',
                hasEditPage: true,
            }
        },
    };
</script>
